import { TemplatePayment } from '../../types.ts'
import { Amount, BooleanRenderer, DataRow, LinkRenderer, Text } from '../../components'

export const MAIN_INFO_LABELS: Array<DataRow<TemplatePayment>> = [
  { key: 'paymentInfoShort', label: 'Название', renderer: Text },
  { key: 'paymentInfoFull', label: 'Описание', renderer: Text },
  { key: 'amount', label: 'Сумма', renderer: Amount },
  { key: 'paymentCountLimit', label: 'Кол-во возможных платежей', renderer: Text },
  { key: 'url', label: 'Ссылка', renderer: LinkRenderer },
]

export const ADDITIONAL_INFO_LABELS: Array<DataRow<TemplatePayment>> = [
  { key: 'unit', label: 'Единица измерения', renderer: Text },
  { key: 'createTime', label: 'Дата создания', renderer: Text },
  { key: 'validTo', label: 'Действительна до', renderer: Text },
  { key: 'amountUnitsNeeded', label: 'Указание количества при создании платежа', renderer: BooleanRenderer },
  { key: 'agreementNeeded', label: 'Номер договора при создании платежа', renderer: BooleanRenderer },
  { key: 'addressNeeded', label: 'Адреса доставки при создании платежа', renderer: BooleanRenderer },
  { key: 'freeSumAvailable', label: 'Доступность ввода любой суммы при создании платежа', renderer: BooleanRenderer },
]
